import React from "react"
import Layout from "components/layout"
import SEO from "components/seo"
import { graphql } from "gatsby"
import { CaseStudyIndexTemplate } from "../../components/Templates/CaseStudyIndexTemplate"

const CaseStudyIndex = ({ data }) => {
  const { content, seo, featuredImage } = data.page

  return (
    <Layout variant="landing" pageContext={data?.page}>
      <SEO
        title={seo.title}
        image={featuredImage?.node?.sourceUrl}
        description={seo.metaDesc}
      />
      <CaseStudyIndexTemplate
        pages={data.allWpPage.nodes}
        content={content}
        pageIndex
      />
    </Layout>
  )
}

export default CaseStudyIndex

export const pageQuery = graphql`
  query($id: String!) {
    page: wpPage(id: { eq: $id }) {
      title
      excerpt
      content
      uri
      ancestors {
        nodes {
          ... on WpPage {
            depth
            title
            uri
          }
        }
      }
      seo {
        title
        metaDesc
      }
      headerSettings {
        customPageTitle
      }
      featuredImage {
        node {
          sourceUrl
          srcSet
          mediaDetails {
            height
            width
          }
        }
      }
    }

    allWpPage(
      filter: { wpParent: { node: { id: { eq: $id } } } }
      sort: { fields: menuOrder, order: ASC }
    ) {
      nodes {
        title
        uri
        title
        menuOrder
        excerpt
        featuredImage {
          node {
            sourceUrl
            srcSet
            mediaDetails {
              height
              width
            }
          }
        }
      }
    }
  }
`
